"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var get_vod_api_url_1 = require("./get-vod-api-url");
var globalHosts;
if (typeof HOSTS !== 'undefined') {
    // eslint-disable-line no-undef
    globalHosts = HOSTS; // eslint-disable-line no-undef
}
var catalogBaseURL = get_vod_api_url_1.getVODApiUrl(globalHosts.catalog);
exports.hosts = tslib_1.__assign(tslib_1.__assign({}, globalHosts), { publicCatalog: catalogBaseURL, catalog: catalogBaseURL + "/api/v2" });
//# sourceMappingURL=settings.js.map